<!-- 供应链列表页 -->
<template>
  <div class="supplyChain">
    <!-- 搜索条件 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      :labelWidth="labelWidth"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    >
    </sirui-search>
    <!-- 表格内容 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'requestStatus'">
              <dict-span dictType="request_status" v-model="scope.row[item.field]"></dict-span>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 导入 -->
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getData"
      ref="siruiUpload"
    >
    </sirui-upload>
    <!-- 查重弹窗 -->
    <check ref="check" />
    <!-- 合并弹窗 -->
    <merge ref="merge" @getData="getData" />

    <!-- 扩展申请弹窗 -->
    <expand ref="expand" :extendRequestDepartmentList="departmentList" />
  </div>
</template>

<script>
  import API from '@/api/masterData/supplyChain';
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import siruiUpload from '@/components/SiruiUpload';
  import DictSpan from '@/components/DictSpan';
  import Check from './dialog/check';
  import Merge from './dialog/merge';
  import BASE_API from '@/api/dataBase';
  import Expand from './dialog/expand';
  export default {
    name: 'supplyChain',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      siruiUpload,
      DictSpan,
      Check,
      Merge,
      Expand,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
        // 状态 => 用于表格回显
        requestStatusData(state) {
          let dictList = state.dict.dictList;
          if (dictList.length > 10) {
            return dictList.find((it) => it.dictType == 'request_status').dictList;
          } else {
            return [];
          }
        },
      }),
      searchColumns() {
        let searchColumns = [
          {
            name: this.$t('supplyChain.label.startTime'),
            prop: 'requestTimeBegin',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('supplyChain.label.endTime'),
            prop: 'requestTimeEnd',
            type: 'endDaterangePicker',
          },
          {
            prop: 'supplierName',
            name: this.$t('supplyChain.label.supplierName'),
            type: 'searchTable',
            width: '800',
            isMultiple: true,
            page: false,
            placeholder: this.$t('supplyChain.placeholder.input'),
            query: {
              supplierName: '',
              supplierCode: '',
              searchCode: '',
              adminFlag: this.userInfo.adminFlag,
              requestStatus: 'ZT03',
              distinctFlag: true,
            },
            searchColumns: [
              {
                prop: 'supplierName',
                name: this.$t('supplyChain.label.supplierName'),
                type: 'input',
                placeholder: this.$t('supplyChain.label.writeSupplierName'),
              },
              {
                prop: 'supplierCode',
                name: this.$t('supplyChain.label.supplierCode'),
                type: 'input',
                placeholder: this.$t('supplyChain.label.writeSupplierCode'),
              },
              {
                prop: 'searchCode',
                name: this.$t('supplyChain.label.searchCode'),
                type: 'input',
                placeholder: this.$t('supplyChain.label.writeSearchCode'),
              },
            ],
            API: API.LIST_SUPPLIERS,
            propName: 'supplierName',
            columnList: [
              { prop: 'supplierName', label: this.$t('supplyChain.label.supplierName') },
              { prop: 'supplierCode', label: this.$t('supplyChain.label.supplierCode') },
              { prop: 'searchCode', label: this.$t('supplyChain.label.searchCode') },
            ],
          },
          {
            name: this.$t('supplyChain.label.status'),
            prop: 'requestStatus',
            type: 'dict',
            dictType: 'request_status',
          },
          {
            name: '选择视图',
            prop: 'selectView',
            type: 'select',
            options: this.selectViewList,
          },
        ];
        let obj = {
          name: '部门',
          prop: 'departmentCodesArr',
          type: 'treeSelect',
          apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
          apiData: {
            tenantCode: this.userInfo.tenantCode,
            adminFlag: this.userInfo.adminFlag,
            selfCompanyDepartmentTreeFlag: true,
          },
          span: 12,
          multiple: true,
        };
        if (this.searchForm.selectView != '00') searchColumns.push(obj);
        return searchColumns;
      },
      labelWidth() {
        return '120px';
      },
    },
    watch: {
      'searchForm.selectView': {
        handler(newName) {
          if (newName == '00') this.query.departmentCodesArr = '';
        },
      },
    },
    data() {
      return {
        searchForm: {
          // 搜索条件
          applyStatu: null,
          supplierName: null, //数组
          supplierReallyName: null, //用于暂存supplierName
          requestTimeBegin: null,
          requestTimeEnd: null,
          selectView: '00',
          departmentCodesArr: '',
        },
        departmentList: [],
        tableData: [],
        multipleSelection: [],
        menuButtonList: [],
        load: false,
        importUrl: '', // 导入地址
        importData: {}, // 导入参数
        selectViewList: [
          {
            value: '00',
            label: '基本视图',
          },
          {
            value: '01',
            label: '扩展视图',
          },
        ], //视图下拉
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'supplierName',
            title: 'supplyChain.label.supplierName',
            visible: true,
          },
          {
            field: 'supplierCode',
            title: 'supplyChain.label.supplierCode',
            visible: true,
          },
          {
            field: 'creditCode',
            title: 'cooperation.label.creditCode',
            visible: true,
          },
          {
            field: 'requestPersonName',
            title: 'cooperation.label.requestBy',
            visible: true,
          },
          {
            field: 'requestTime',
            title: 'cooperation.label.requestTime',
            visible: true,
          },
          {
            field: 'requestStatus',
            title: 'cooperation.label.requestStatus',
            visible: true,
          },
        ],
      };
    },
    created() {
      // const tenantCode = this.userInfo.tenantCode; // 租户编码
      // 获取部门数据
      this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
        if (res.data.code === 0) {
          this.departmentList = res.data.data.personDepartmentInfo;
        }
      });
    },
    mounted() {
      this.$nextTick(() => {
        //查询列表数据
        this.getData();
        //动态获取查询结果按钮及表头
        this.getButtonList();
        //设置导入参数
        this.setImport();
      });
    },
    methods: {
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'export') {
          this.handleExport();
        } else if (value === 'enable') {
          this.handleEnable('ZT03');
        } else if (value === 'forbid') {
          this.handleForbid('ZT04');
        } else if (value === 'check') {
          this.handleCheck();
        } else if (value === 'merge') {
          this.handleMerge();
        } else if (value === 'import') {
          this.handleImport();
        } else if (value === 'reject') {
          this.handleReject('ZT05');
        } else if (value === 'approval') {
          this.handleReject('ZT03');
        } else if (value === 'expand') {
          this.expand();
        }
      },
      // 扩展按钮点击事件
      expand() {
        if (this.multipleSelection.length !== 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
          return;
        }
        let flag = this.multipleSelection.findIndex((item) => item.requestStatus == 'ZT03');
        if (flag == -1) {
          this.$message({
            showClose: true,
            message: '只有已生效的才可以扩展！',
            type: 'error',
          });
          return;
        }
        console.log(this.multipleSelection);
        let info = this.multipleSelection[0];
        let companyInfo = {
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
          departmentName: info.departmentName,
          departmentCode: info.departmentCode,
        };
        let propsPartnerData = {
          id: info.id,
          supplierCode: info.supplierCode,
          supplierName: info.supplierName,
        };
        // console.log(companyInfo);
        this.$refs.expand.openDialog(propsPartnerData, this.departmentList, companyInfo);
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData();
      },
      getData() {
        this.load = true;
        if (this.searchForm.supplierName) {
          this.searchForm.supplierReallyName = this.searchForm.supplierName[0].supplierName;
        }
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { adminFlag, tenantCode, companyCode } = this.userInfo;
        let params = { pageNum, pageSize, adminFlag, tenantCode, companyCode };
        params = Object.assign(params, this.searchForm);
        params.supplierName = this.searchForm.supplierReallyName;
        this.$axios.post(API.LIST_SUPPLIERS, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            this.$refs.siruiTable.reloadTable(this.tableData); // 删除表格选中的状态
          }
        });
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        for (let i in this.searchForm) {
          this.searchForm[i] = null;
        }
        this.getData();
      },
      // 新增
      handleAdd() {
        let path = {
          path: '/masterData/addSupplyChain',
          name: 'addSupplyChain',
          meta: {
            keepAlive: false,
            title: this.$t('supplyChain.router.add'),
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      handleExport() {
        let tableColumn = this.$refs.siruiTable.getTableColumn().visibleColumn;
        let showColumns = [];
        let idList = [];
        tableColumn.forEach((item) => {
          if (item.property) showColumns.push({ prop: item.property });
        });
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            idList.push(item.supplierCode);
          });
        }
        const { tenantCode, companyCode, departmentCode } = this.userInfo;
        let params = { tenantCode, companyCode, departmentCode };
        params = Object.assign(params, this.searchForm);
        params.columns = showColumns;
        params.ids = idList;
        this.$axios.post(API.EXPORT_SUPPLIERS, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          }
        });
      },
      // 启用
      handleEnable(requestStatus) {
        if (this.multipleSelection.length > 0) {
          let params = [];
          for (let item of this.multipleSelection) {
            if (item.requestStatus === 'ZT04') {
              let { id, version, supplierCode } = item;
              let obj = { id, version, requestStatus, supplierCode };
              params.push(obj);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('cooperation.message.enable_to_forbid'),
                type: 'error',
              });
              return false;
            }
          }
          this.$axios.post(API.ENABLE_SUPPLIER, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getData();
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 禁用
      handleForbid(requestStatus) {
        if (this.multipleSelection.length > 0) {
          let params = [];
          for (let item of this.multipleSelection) {
            if (item.requestStatus === 'ZT03') {
              let { id, version, supplierCode } = item;
              let obj = { id, version, requestStatus, supplierCode };
              params.push(obj);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('cooperation.message.forbid_to_enable'),
                type: 'error',
              });
              return false;
            }
          }
          this.$axios.post(API.ENABLE_SUPPLIER, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getData();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      //驳回,审批
      handleReject(val) {
        if (this.resolveSelected('more')) {
          // 可多选
          let isRequestStatus = this.multipleSelection.every(
            (item) => item.requestStatus == 'ZT02'
          );
          let idList = [];
          this.multipleSelection.forEach((item) => {
            if (item.requestStatus == 'ZT02') {
              idList.push(item.id);
            }
          });
          if (isRequestStatus) {
            let params = {
              idLists: idList,
              requestStatus: val,
            };
            this.$axios.post(API.UPDATE_IS_REJECT, params).then((res) => {
              if (res.data.code === 0) {
                this.$refs.siruiTable.clearCheckboxReserve();
                this.getData();
                this.multipleSelection = [];
                this.$refs.siruiTable.clearCheckboxReserve();
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('goods.message.importError'),
              type: 'error',
            });
          }
        }
      },
      // 查重
      handleCheck() {
        if (this.multipleSelection.length === 1) {
          this.$refs.check.openDialog(this.multipleSelection[0]);
        } else {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
          return false;
        }
        return true;
      },
      // 合并
      handleMerge() {
        if (this.multipleSelection.length === 1) {
          if (this.multipleSelection[0].requestStatus === 'ZT03') {
            // 已生效状态才可以有合并操作
            this.$refs.merge.openDialog(this.multipleSelection[0]);
          } else {
            this.$message({
              showClose: true,
              message: this.$t('cooperation.message.merge_need_enable'),
              type: 'error',
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 批量导入
      handleImport() {
        this.$refs.siruiUpload.openDialog(true);
      },
      // 设置导入配置
      setImport() {
        this.importUrl = API.IMPORT_SUPPLIER;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          lang: this.lang,
        };
      },
      // 双击行
      dblclickEvent(value) {
        let propData = {
          departmentCode: value.row.departmentCode,
          id: value.row.id,
          supplierCode: value.row.supplierCode,
        };
        let path = {
          path: '/masterData/editSupplyChain',
          name: 'editSupplyChain',
          meta: {
            keepAlive: false,
            title: this.$t('supplyChain.router.edit'),
          },
          query: {
            propData: JSON.stringify(propData),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 修改条数
      handleSizeChange() {
        this.getData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
      // 表格选择行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>

<style scoped></style>
